import { CatalogActions } from './action-creators';
import * as actions from './actions';
import { CatalogState } from './state';
import { catalogInitialState } from './initial-state';

const getSection = (
  ownerType: 'OWNER' | 'WRITER' | 'COLLABORATOR'
): Exclude<keyof CatalogState, 'sorting'> => {
  if (ownerType === 'OWNER') {
    return 'master';
  }

  if (ownerType === 'COLLABORATOR') {
    return 'collaborator';
  }

  return 'publishing';
};

export const catalogReducer = (
  state: CatalogState = catalogInitialState,
  action: CatalogActions
): CatalogState => {
  switch (action.type) {
    case actions.GET_CATALOG: {
      return {
        ...state,
        sorting: action.params.sortBy || 'default',
      };
    }

    case actions.GET_CATALOG_SUCCESS:
      return {
        ...state,
        [getSection(action.ownerType)]: {
          items: action.isPaginating
            ? state[getSection(action.ownerType)].items.concat(
                action.catalog.items.filter(
                  (i) =>
                    !state[getSection(action.ownerType)].items.find(
                      (a) => a.id === i.id
                    )
                )
              )
            : action.catalog.items,
          nextToken: action.catalog.nextToken,
        },
      };

    case actions.SORT_CATALOG:
      return {
        ...state,
        sorting: action.sortBy,
      };

    case actions.RESET_CATALOG_STORE:
      return catalogInitialState;

    case actions.RESET_ARTIST_CATALOG_STORE:
      return {
        ...state,
        collaborator: { ...catalogInitialState.collaborator },
      };

    case actions.CREATE_COMBINED_CATALOG:
      return {
        ...state,
        releases: {
          items: state.master.items
            .concat(
              state.collaborator.items.filter(
                (i) => !state.master.items.some((m) => m.id === i.id)
              )
            )
            .sort((a, b) => {
              if (a.created_at && b.created_at) {
                if (
                  new Date(a.created_at).getDate() ===
                  new Date(b.created_at).getDate()
                ) {
                  return String(b.release_date ?? '').localeCompare(
                    String(a.release_date) ?? ''
                  );
                }
                return (
                  new Date(b.created_at).getTime() -
                  new Date(a.created_at).getTime()
                );
              }
              return a.created_at ? -1 : b.created_at ? 1 : 0;
            }),
          nextToken: null,
        },
      };

    default:
      return state;
  }
};
